<div class="guardrails" [formGroup]="formGroup">
  <div class="guardrails__header">
    <pdq-heading element="h6" class="guardrails__header-title">MAXX AI Guardrails</pdq-heading>
    <span class="maxx-ai-badge">MAXX AI</span>
  </div>

  <div class="guardrails__range">
    <pdq-heading element="h6" class="guardrails__range-title"
      >{{ isPercentage ? 'Percentage' : 'Amount' }} range</pdq-heading
    >
    <div class="guardrails__range-inputs">
      <pdq-input-arrows
        [formControl]="formGroup.get('min')"
        label="Min"
        [placeholder]="isPercentage ? 'e.g. 5' : 'e.g. 1'"
        [symbol]="symbol"
        precision="2"
        min="1"
        [max]="maxBound"
        [required]="false"
        widthSize="auto">
      </pdq-input-arrows>
      <pdq-input-arrows
        [formControl]="formGroup.get('max')"
        label="Max"
        [placeholder]="isPercentage ? 'e.g. 30' : 'e.g. 20'"
        [symbol]="symbol"
        precision="2"
        min="1"
        [max]="maxBound"
        [required]="false"
        widthSize="auto">
      </pdq-input-arrows>
    </div>
    @if (rangeErrorMessage && (rangeErrorKind === 'invalid' || formGroup.dirty)) {
      <pdq-banner
        class="guardrails__range-banner"
        variant="danger"
        [closable]="false"
        inline="true"
        [bannerTitle]="rangeErrorMessage">
      </pdq-banner>
    } @else if (showRecommendation) {
      <pdq-banner
        class="guardrails__range-banner"
        variant="attention"
        [closable]="false"
        inline="true"
        bannerTitle="For best results, keep the range between Min and Max greater than 5.">
      </pdq-banner>
    }
  </div>

  <div class="guardrails__arms">
    <pdq-heading element="h6" class="guardrails__range-title">Allowed actions</pdq-heading>
    <pdq-checkbox
      [formControl]="formGroup.get('allowZero')"
      label="Allow $0 coupon (hides the gift unlock when chosen)"
      labelSize="small">
    </pdq-checkbox>
  </div>
</div>
